module.exports = __webpack_public_path__ + "media/content-creator/fmcg-3-79bf411c.png";